// src/api/users.js
import adminRequest from "./adminClient";

// 일반 회원 등록 (백엔드: POST /users/register)
export const registerUser = (payload) =>
    adminRequest("/users/register", { method: "POST", body: payload });

export const registerUserForm = (payload = {}, file) => {
    const fd = new FormData();
    Object.entries(payload).forEach(([k, v]) =>
        fd.append(k, typeof v === "boolean" ? String(v) : v ?? "")
    );
    if (file) fd.append("image", file);   // 파일은 선택
    return adminRequest("/auth/register", { method: "POST", body: fd });
};


export const fetchUsersForAdmin = async ({ q = "", skip = 0, limit = 50 } = {}) => {
    const params = new URLSearchParams();
    if (q) params.set("q", q);
    if (Number.isFinite(skip)) params.set("skip", String(skip));
    if (Number.isFinite(limit)) params.set("limit", String(limit));

    const path = `/admin/users${params.toString() ? `?${params.toString()}` : ""}`;
    // adminRequest가 자동으로 Authorization 헤더 붙여줌 (adm_token)
    return adminRequest(path, { method: "GET" });
};